// extracted by css-extract-rspack-plugin
export default {"cls1":"HeroWorkCardHeader-cls1_w4r","cls2":"HeroWorkCardHeader-cls2_XYb HeroWorkCardHeader-cls1_w4r"};